module.exports = __webpack_public_path__ + "static/media/12.93dcb444.jpg";